import { SubscribersGrowthIcon } from "../../../../icons";
import { chartLegends } from "../../constants";

import styles from "./styles.module.scss";

export const ChartHeader = () => {
  return (
    <div className={styles.header}>
      <div className={styles.headingWithIcon}>
        <div className={styles.circleWithIcon}>
          <SubscribersGrowthIcon />
        </div>
        <div className={styles.title}>
          Growth of Subscribers Per Application
        </div>
      </div>
      <div className={styles.chartLegends}>
        {chartLegends?.map((item) => (
          <div className={styles.chartLegend} key={item.label}>
            <span style={{ background: item.background }} />
            {item.label}
          </div>
        ))}
      </div>
    </div>
  );
};
